// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"5b2b50c3","453":"241a54d4","727":"2d5f8b05","825":"000e2766","836":"f8272cf1"}[chunkId] + ".chunk.js";
};